import { render, staticRenderFns } from "./CommonComponent.vue?vue&type=template&id=ffb10a9c"
import script from "./CommonComponent.vue?vue&type=script&lang=js"
export * from "./CommonComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports